import { Container } from "../../../../components/Container";
import { Logo, LogoSize } from "../../../../components/Logo";
import UkrSibBank from "../../../../assets/img/partners/urkSibBank.svg";
import Vodafone from "../../../../assets/img/partners/vodafone.svg";
import LogoPab from "../../../../assets/img/PabLogo.svg";
import { Button, ButtonType } from "../../../../components/Button";
import classNames from "classnames/dedupe";
import styles from "./Banner.module.sass";
import { useEffect } from "react";

export const Banner = () => {
  useEffect(() => {
    setTimeout(function () {
      // @ts-ignore
      document.querySelector("#video")?.play();
    }, 1000);
  });

  return (
    <div className={styles.root}>
      <div className={styles.bannerWrapper}>
        <iframe
          className="img"
          src="https://www.youtube.com/embed/gq1CSmikHmA?playlist=gq1CSmikHmA&autoplay=1&mute=1&controls=0&playsinline=1&loop=1&start=4"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
          allowFullScreen
        ></iframe>
      </div>

      <Container className={classNames("df-center", styles.container)}>
        <Logo className={styles.logo} size={LogoSize.medium} />
        <h1 className={styles.title} data-aos="fade-up">
          ПЕРШИЙ ПОЛТАВСЬКИЙ БІЗНЕС-ФОРУМ
        </h1>
        <div className="df-between">
          <p className={styles.subtitle}>13 БЕРЕЗНЯ</p>
          <hr className={styles.line} />
          <p className={styles.subtitle}>ПОЛТАВА</p>
        </div>
        <div className={classNames("df-between", styles.info)}>
          <div
            className={classNames(
              "df-center fd-column",
              styles.infoBlock,
              styles.infoMain,
            )}
          >
            <p>Організатор</p>
            <img src={LogoPab} alt="logo: Pab" />
          </div>
          <div className={classNames("df-center", styles.mb2, styles.fullBtn)}>
            <Button
              size={ButtonType.Medium}
              className={classNames(styles.btn)}
            />
          </div>
          <div className={classNames("df-center fd-column", styles.infoBlock)}>
            <p>Головні партнери</p>
            <div className="df-center">
              <img src={UkrSibBank} alt="logo: UKRSIBBANK" />
              <img src={Vodafone} alt="logo: Vodafone" />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
